import { render, staticRenderFns } from "./resultModal.vue?vue&type=template&id=48199d1e&scoped=true"
import script from "./resultModal.vue?vue&type=script&lang=js"
export * from "./resultModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48199d1e",
  null
  
)

export default component.exports